/** Read bounded UTF-8 text without changing the uploaded source. */
export async function readSpecificationText(file: File, maxBytes: number): Promise<string> {
  if (file.size === 0) throw new Error(`${file.name} is empty.`);
  if (file.size > maxBytes) throw new Error(`${file.name} exceeds the ${Math.floor(maxBytes / 1024)} KiB file limit.`);
  if (/\.pdf$/i.test(file.name)) throw new Error('PDF guides belong in the reference library. Select the published schema or code-list text file.');
  const bytes = await new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error(`${file.name} could not be read.`));
    reader.onload = () => reader.result instanceof ArrayBuffer ? resolve(reader.result) : reject(new Error(`${file.name} could not be read.`));
    reader.readAsArrayBuffer(file);
  });
  try { return new TextDecoder('utf-8', { fatal: true, ignoreBOM: true }).decode(bytes); }
  catch { throw new Error(`${file.name} must be a UTF-8 text file.`); }
}
